import { defineStore } from 'pinia'
import { ref } from 'vue'

import { Suggestion } from '@/interfaces/mapboxSearchSuggestResponse'

import { User } from '@/modules/users/interfaces/user'

interface Reservation {
	destination: Suggestion | undefined
	travelers: User[]
	member: User
	dates: string[]
	guestCount: number
}

export const useReservationStore = defineStore(
	'reservation',
	() => {
		const reservation = ref<Reservation>()

		return {
			reservation,
			setReservation(value: Reservation) {
				reservation.value = value
				localStorage.setItem('reservationRequest', JSON.stringify(value))
			},
			resetReservation() {
				reservation.value = undefined
				localStorage.removeItem('reservationRequest')
			},
		}
	},
	{
		persist: {
			storage: localStorage,
			paths: ['reservationRequest'],
		},
	}
)
